import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { createOfferProvider } from 'di';

import { DetailedOffer } from '../../../../../api-client/models/offer/DetailedOffer';
import { Container, Loader, Section } from '../../../../../components';
import { useErrorCallback, useLoading } from '../../../../../hooks';
import SecondaryProject from './SecondaryProject';

import './PurchaseOffer.scoped.scss';

const PurchaseOffer = () => {
  const { offerUuid } = useParams();
  const [offer, setOffer] = useState<DetailedOffer | null>(null);
  const errorCallback = useErrorCallback();
  const [loading, withLoading] = useLoading();
  useEffect(() => {
    const callback = async () => {
      try {
        const provider = await createOfferProvider();
        const offer = await provider.getOne(offerUuid!);
        setOffer(offer);
      } catch (err: any) {
        await errorCallback(err);
        setOffer(null);
      }
    };
    (async () => {
      await withLoading(callback);
    })();
  }, []);

  return (
    <Container>
      <Section>
        {loading && <Loader />}
        {!loading && offer === null && <div>Предложение не найдено</div>}
        {offer && <SecondaryProject offer={offer!} />}
      </Section>
    </Container>
  );
};

export default PurchaseOffer;
